import { api } from "./axios";

export async function getAllComplians() {
    let res = await api.get("complians/index");
    if (res) return res.data.data;
    else return false;
}
export async function updateComplians(id, data) {
    let res = await api.post("complians/update/" + id, data);
    if (res) return res.data.data;
    else return false;
}

export async function deleteComplians(id) {
    let res = await api.get("complians/destroy/" + id);
    if (res) return res.data.data;
    else return false;
}